import { useTranslation } from 'react-i18next'

import { EMAIL_MESSAGES_SEARCH_API } from '../../../constants/api'
import { SEARCH_RESULTS_EMAILS_ENTITY } from '../../../constants/entity'
import {
  ROUTE_PATH_LIST,
  SUBMENU_PARAM_ARCHIVE_VALUE,
} from '../../../constants/route'
import { useInitData, useLinkLikeClick } from '../../../hooks'
import { getEmailProfilePathname } from '../../../utils/link'
import {
  EMAIL_ITEM_ID_KEY,
  EmailTableLayout,
  useEmailTablePage,
} from '../../Email'
import { useSearchResultsTableOptions } from '../SearchResults.hooks'
import { getSearchResultsBreadcrumbs } from '../SearchResults.utils'
import { SearchResultsPage } from '../SearchResultsPage'

import { updateSearchResultsEmailsTableConfig } from './SearchResultsEmails.api'
import {
  QA_NAME_SEARCH_RESULTS_EMAILS_TABLE,
  SEARCH_RESULTS_EMAILS_CONFIG_API,
} from './SearchResultsEmails.constants'

import EmailIcon from '../../../icons/email.svg'

function SearchResultsEmails() {
  const { t } = useTranslation()

  const { availableSections } = useInitData()

  const {
    asyncTableOptions,
    extraSelectionResetDeps,
    isArchived,
    searchQuery,
  } = useSearchResultsTableOptions({
    asyncTableOptions: {
      itemIdKey: EMAIL_ITEM_ID_KEY,
      listApi: EMAIL_MESSAGES_SEARCH_API,
      tableConfigApi: SEARCH_RESULTS_EMAILS_CONFIG_API,
    },
  })

  const tablePage = useEmailTablePage({
    asyncTableOptions,
    entity: SEARCH_RESULTS_EMAILS_ENTITY,
    extraSelectionResetDeps,
    pageTitle: t('SearchResults.EmailsBrowserTabTitleKey'),
    onApplyTableConfig: updateSearchResultsEmailsTableConfig,
  })

  const { handleClick, handleMouseDown } = useLinkLikeClick()

  function getEmailProfileLink(id) {
    return getEmailProfilePathname({
      availableSections,
      id,
      singleEmailAccount: true,
      sub: isArchived ? SUBMENU_PARAM_ARCHIVE_VALUE : null,
    })
  }

  function handleClickRow(id, event) {
    handleClick({ event, link: getEmailProfileLink(id) })
  }

  function handleMouseDownRow(id, event) {
    handleMouseDown({ event, link: getEmailProfileLink(id) })
  }

  const breadcrumbs = getSearchResultsBreadcrumbs({
    leadingBreadcrumbs: [
      {
        id: 'mails',
        title: t('BrowserTab.EmailsPageTitleKey'),
        to: `/${ROUTE_PATH_LIST.mails}/`,
      },
    ],
    searchQuery,
    t,
  })

  return (
    <SearchResultsPage
      EntityIcon={EmailIcon}
      TableLayout={EmailTableLayout}
      breadcrumbs={breadcrumbs}
      emptyText={t('Emails.NoDataKey')}
      layoutProps={{
        rowExtraProps: {
          singleEmailAccount: true,
          onClick: handleClickRow,
          onMouseDown: handleMouseDownRow,
        },
        skeletonProps: { withCheckbox: false },
        withRowActions: false,
      }}
      qaName={QA_NAME_SEARCH_RESULTS_EMAILS_TABLE}
      tablePage={tablePage}
    />
  )
}

export default SearchResultsEmails
